import React from "react";
import PropTypes from "prop-types";

import styled from "styled-components";

const TwoColTable = styled.table`
    width: 100%;
`

const Table = ({ children }) => (
  <TwoColTable>
    <tbody>{children}</tbody>
  </TwoColTable>
);

Table.propTypes = {
    children: PropTypes.node.isRequired
    // children: PropTypes.any.isRequired
};

export default Table;



// WEBPACK FOOTER //
// ./src/components/Table/index.js